import React, {useState, useEffect, useRef} from "../../../../__snowpack__/pkg/react.js";
import {localeMessage} from "../i18n.js";
import {isEmpty, map} from "../../../../__snowpack__/pkg/lodash.js";
import {Select, InputNumber, Tooltip, Popover} from "../../../../__snowpack__/pkg/antd.js";
import {ExclamationCircleFilled} from "../../../../__snowpack__/pkg/@ant-design/icons.js";
import {useLanguageModel} from "../../../store/language.js";
import {moneyRenderer} from "../../stock-in-out-record/includes/utils.js";
import {useIntlTyped} from "../../../lib/useIntlTyped.js";
import {useCountryInfo} from "../../../entities/useCountryInfo.js";
import {eventLogger} from "../../../lib/eventLogger.js";
export const EditableTableCell = (props) => {
  const {formatMessage} = useIntlTyped(localeMessage);
  const {
    text,
    record,
    index,
    onChange,
    dataIndex,
    onErrorChange,
    updateEditingStatus,
    showCurrency
  } = props;
  const {CountryList, fetchCountryList} = useCountryInfo();
  const currencyRef = useRef(null);
  const [isEditing, setIsEditing] = useState(false);
  const [touched, setTouched] = useState(false);
  const {language} = useLanguageModel();
  const [currentValue, setCurrentValue] = useState(record[dataIndex]);
  const [currentCurrencyValue, setCurrentCurrencyValue] = useState(record.currencyCode);
  useEffect(() => {
    fetchCountryList();
    setCurrentValue(record[dataIndex]);
    setCurrentCurrencyValue(record.currencyCode);
    if (dataIndex === "warehouseStockChange") {
      setIsEditing(record.isEditingStockChange);
    } else if (dataIndex === "newWarehouseStock") {
      setIsEditing(record.isEditingLatestStock);
    } else if (dataIndex === "batchPurchasePrice") {
      setIsEditing(record.isEditingPrice);
    }
  }, [record]);
  const handleChange = (value) => {
    if (!touched) {
      setTouched(true);
    }
    setCurrentValue(value);
  };
  const handelCurrencyChange = (value) => {
    if (!touched) {
      setTouched(true);
    }
    setCurrentCurrencyValue(value);
    onChange(index, dataIndex, currencyRef.current?.state.value, value);
    setTouched(false);
  };
  const handleBlur = (e) => {
    setIsEditing(false);
    const value = e.target.value;
    if (touched && /^-?\d+\.?(\d+)?$|^$/.test(value)) {
      onChange(index, dataIndex, value, currentCurrencyValue);
      setTouched(false);
    }
    updateEditingStatus(index, dataIndex, false);
  };
  const myTextRenderer = (text2) => {
    if (/^$|^undefined|null$/.test(text2)) {
      if (dataIndex === "newWarehouseStock") {
        return /* @__PURE__ */ React.createElement("span", {
          style: {color: "#6020ff"}
        }, "+Add");
      } else {
        return /* @__PURE__ */ React.createElement("span", {
          style: {color: "#f00"}
        }, "+Add");
      }
    } else {
      return /* @__PURE__ */ React.createElement(Tooltip, {
        title: formatMessage({id: "clickToEdit"})
      }, /* @__PURE__ */ React.createElement("span", {
        style: {
          color: errorMsg ? "#f00" : dataIndex === "warehouseStockChange" || dataIndex === "newWarehouseStock" || dataIndex === "batchPurchasePrice" ? "#6020ff" : ""
        }
      }, dataIndex === "batchPurchasePrice" ? moneyRenderer(text2, "", currentCurrencyValue) : text2));
    }
  };
  const [errorMsg, setErrorMsg] = useState("");
  useEffect(() => {
    if ([void 0, null, ""].includes(currentValue)) {
      if (dataIndex === "batchPurchasePrice") {
        if (/^\d+\.?(\d+)?$/.test(currentValue) && Number(currentValue) >= 0 && Number(currentValue) <= 1e9) {
          setErrorMsg("");
        } else if (record.warehouseStockChange >= 0) {
          setErrorMsg(/* @__PURE__ */ React.createElement("span", {
            style: {color: "#f5222d"}
          }, formatMessage({id: "priceError"})));
        }
        return;
      } else {
        setErrorMsg("");
        return;
      }
    }
    if (dataIndex === "warehouseStockChange") {
      if (record.warehouse.provider != "GINEE_LOCAL") {
        if (Number(currentValue) >= 0) {
          setErrorMsg("");
        } else {
          setErrorMsg(/* @__PURE__ */ React.createElement("span", {
            style: {color: "#f5222d"}
          }, formatMessage({id: "decrementThirdPartyWarehouseError"})));
        }
      } else if (/^-?\d+\.?(\d+)?$/.test(currentValue) && Number(currentValue) >= -999999 && Number(currentValue) <= 999999 && Number(currentValue) !== 0) {
        if (+currentValue + record.warehouseStock < 0) {
          setErrorMsg(/* @__PURE__ */ React.createElement("span", {
            style: {color: "#f5222d"}
          }, formatMessage({id: "stockNegativeError"})));
        } else {
          setErrorMsg("");
        }
      } else {
        setErrorMsg(/* @__PURE__ */ React.createElement("span", {
          style: {color: "#f5222d"}
        }, formatMessage({id: "stockNumberChangeError"})));
      }
    } else if (dataIndex === "newWarehouseStock") {
      if (/^\d+\.?(\d+)?$/.test(currentValue) && Number(currentValue) >= 0 && Number(currentValue) <= 999999) {
        setErrorMsg("");
      } else if (+currentValue < 0) {
        setErrorMsg(/* @__PURE__ */ React.createElement("span", {
          style: {color: "#f5222d"}
        }, formatMessage({id: "stockNegativeError"})));
      } else {
        setErrorMsg(/* @__PURE__ */ React.createElement("span", {
          style: {color: "#f5222d"}
        }, formatMessage({id: "stockNumberError"})));
      }
    } else if (dataIndex === "batchPurchasePrice") {
      if (/^\d+\.?(\d+)?$/.test(currentValue) && Number(currentValue) >= 0 && Number(currentValue) <= 1e9) {
        setErrorMsg("");
      } else if (record.warehouseStockChange >= 0) {
        setErrorMsg(/* @__PURE__ */ React.createElement("span", {
          style: {color: "#f5222d"}
        }, formatMessage({id: "priceError"})));
      }
    }
  }, [currentValue, record[dataIndex]]);
  useEffect(() => {
    onErrorChange(index, dataIndex, errorMsg);
  }, [errorMsg]);
  if (record.type === "PROMOTION") {
    return /* @__PURE__ */ React.createElement("span", {
      style: {color: "#adbacc"}
    }, "-");
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, dataIndex === "batchPurchasePrice" && +record.warehouseStockChange < 0 ? /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Tooltip, {
    placement: "top",
    title: formatMessage({id: "priceUneditableTooltip"})
  }, /* @__PURE__ */ React.createElement(ExclamationCircleFilled, {
    style: {color: "#ADBACC", marginRight: 4}
  })), /* @__PURE__ */ React.createElement("span", null, moneyRenderer(text, "", currentCurrencyValue))) : isEditing ? /* @__PURE__ */ React.createElement(Popover, {
    content: errorMsg,
    visible: !!errorMsg
  }, /* @__PURE__ */ React.createElement("span", {
    style: {display: "flex", justifyContent: "flex-start"}
  }, showCurrency && /* @__PURE__ */ React.createElement(Select, {
    style: {flex: 1},
    optionLabelProp: "aria-label",
    onChange: handelCurrencyChange,
    defaultValue: currentCurrencyValue
  }, !isEmpty(CountryList) && map(CountryList, (item) => /* @__PURE__ */ React.createElement(Select.Option, {
    value: item.currencyCode,
    "aria-label": item.currencySymbol,
    key: item.countryCode
  }, item.currencyCode))), /* @__PURE__ */ React.createElement(InputNumber, {
    defaultValue: record[dataIndex],
    autoFocus: !showCurrency,
    ref: (ref) => currencyRef.current = ref,
    onBlur: handleBlur,
    onChange: handleChange,
    onPressEnter: (e) => setTimeout(() => handleBlur(e)),
    style: {width: "100%", flex: 2}
  }))) : /* @__PURE__ */ React.createElement("div", {
    onClick: () => {
      if (dataIndex === "warehouseStockChange") {
        eventLogger.push({
          action: "EditMovement",
          location: "EditWarehouseStock"
        });
      } else if (dataIndex === "newWarehouseStock") {
        eventLogger.push({
          action: "EditLatestStock",
          location: "EditWarehouseStock"
        });
      } else if (dataIndex === "batchPurchasePrice") {
        eventLogger.push({
          action: "EditUnitPurchasePrice",
          location: "EditWarehouseStock"
        });
      }
      setIsEditing(true);
    },
    style: {cursor: "pointer", height: "1.5715em"}
  }, myTextRenderer(record[dataIndex])));
};
export default EditableTableCell;
